import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ViewChild } from '@angular/core';

import { JssEngine } from '../../../../core/json-form/model/jss-engine';
import { JssTreeObject } from '../../../../core/json-form/model/jss-tree-object';
import { LytTreeContainer } from '../../../../core/json-form/model/lyt-tree-container';
import { JssNodeAbstract } from '../../../../core/json-form/model/jss-tree-abstract';
import { jsonFormConfig } from '../../config/json-form.config';

@Component({
   selector: 'app-json-form-view',
   templateUrl: './json-form-view.component.html',
   styleUrls: ['./json-form-view.component.scss']
})
export class JsonFormViewComponent implements OnInit, OnChanges, OnDestroy {

   private _jssEngine: JssEngine = null;
   public  _jssTreeRoot: JssNodeAbstract = null;
   public  _lytTreeRoot: LytTreeContainer = null;

   // input
   @Input('schema') _jsonSchema: any = null;
   @Input('layout') _jsonLayout: any = null;
   @Input('data')   _jsonData: any = null;
   @Input('cancelButton') _cancelButton = false;
   @Input('applyButton')  _applyButton = false;
   @Input('submitButton') _submitButton = true;
   @Input('readonly') _readonly = false;

   // events
   @Output() cancelEvent = new EventEmitter();
   @Output() submitEvent = new EventEmitter<any>();
   @Output() applyEvent  = new EventEmitter<any>();

   constructor(
   ) {
      this._jssEngine = new JssEngine();
   }

   ngOnInit() {
   }

   ngOnChanges() {
      // jsonSchema not initialized or view closed
      if (!this._jsonSchema) {
         this.ngOnDestroy();
         return;
      }

      // -- parse schema --
      if (!this._jssEngine.parse(
         this._jsonSchema,
         this._jsonLayout,
         this._jsonData
      )) {
         console.warn('Error while parsing JsonSchema file');
         return;
      }

      // -- create form --
      this._jssEngine.recveGenFormTree();

      // -- dump tree
      if (jsonFormConfig.dumpTreeContentAfterParseing) {
         this._jssEngine.dumpContent();
      }

      // -- set _lytTreeRoot
      this._lytTreeRoot = this._jssEngine.getRootLytContainer();
      // -- set _jssTreeRoot -> force update --
      this._jssTreeRoot = this._jssEngine.getTreeRoot();
   }

   ngOnDestroy() {
      this._jssEngine = null;
      this._jssTreeRoot = null;
   }

   public resetContent(): void {
      this._jssEngine = null;
      this._jssEngine = new JssEngine();
   }

   // ---------------------------------------------------------------------------------------------
   // -- Event Handler
   // ---------------------------------------------------------------------------------------------
   private onCancel(): void {
      this._jssEngine = null;
      this._jssTreeRoot = null;
      this.cancelEvent.emit();
   }
   private onSubmit(formValue: any): void {
      // formValue is without hidden-pass-through values

      // create data object with hidden-pass-through
      const data: any = this._jssEngine.recveCreateDataObject();
      // send object
      this.submitEvent.emit(data);
   }
   private onApply(formValue: any): void {
      // formValue is without hidden-pass-through values

      // create data object with hidden-pass-through
      const data: any = this._jssEngine.recveCreateDataObject();
      // send object
      this.applyEvent.emit(data);
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/json-form-view/json-form-view.component.ts